module.exports = __webpack_public_path__ + "VIPS2.png?4fc14947fdc839fc60f79050b1152501";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/speedway/VIPS2.png
// module id = 156
// module chunks = 0